import React, { Component } from "react";
import ReactDOM from 'react-dom'
import { decode } from 'js-base64';
import SiteFooter from "../SiteFooter";
import SiteHeader from "../SiteHeader";
import ShortcodeProgram from "./ShortcodeProgram";
import hasCloseEverythingIfNotActiveSelection from "../hoc/hasCloseEverythingIfNotActiveSelection";
import isIframe from "../functions/isIframe";


class ShortcodeApp extends Component {
    constructor(props) {
        super(props)

        this.elemSiteHeader = document.querySelector("#site-header")
        this.elemSiteFooter = document.querySelector("#site-footer")
        this.shortcodes = Array.from(document.querySelectorAll(".pm-shortcode-program"))
    }

    render()  {
        return <>    
            {this.elemSiteHeader && !isIframe && ReactDOM.createPortal(<SiteHeader />,  this.elemSiteHeader)} 
            {this.elemSiteFooter && !isIframe && ReactDOM.createPortal(<SiteFooter />, this.elemSiteFooter)}
            {this.shortcodes.map((node, index) => {
                const data = JSON.parse(decode(node.dataset.program))
                
                return ReactDOM.createPortal(<ShortcodeProgram 
                    data={data} 
                    selectionId={'shortcode-' + index} 
                    {...this.props}
                />, node)
            })}
        </>
    }
}

export default hasCloseEverythingIfNotActiveSelection(ShortcodeApp)